export default __webpack_public_path__ + "static/media/Polimet-850-ban.61774613.jpg";